

























































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import SendTestPushNotificationRequest from '@/models/PushNotifications/SendTestPushNotificationRequest';

@Component({
    name: 'WorkerSendTestPushNotification'
})
export default class extends GiganautVueDialog {
 
  public entity = new SendTestPushNotificationRequest();
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new SendTestPushNotificationRequest();
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }
  
  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await WorkerDetailsModule.sendTestPushNotification(this.entity);
    this.dialog = false;
  }
}
